<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div id="main" style="text-align: center">
            <el-input v-model="form_title" style="width: 240px;" placeholder="标题" />
            <br>
            <el-input v-model="creator" style="width: 240px;padding-bottom: 2rem;" placeholder="填表人" />
            <br>
            <el-row>
                <el-col :span="8" v-for="(i, c) in 9" :key="c" style="padding-bottom: 2rem;">
                    <el-upload class=" upload-demo" v-model:file-list="fileList[c]"
                        action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15" multiple
                        accept=".jpeg,.png,.jpg" list-type="picture-card" :before-upload="checkFileType"
                        :on-preview="handlePreview" :on-change="handleEditChange('#' + c + '>', c)" :auto-upload="false"
                        :limit="1" :id=c>
                        <el-icon>
                            <Plus />
                        </el-icon>
                    </el-upload>
                    <el-button @click="handleCropperPreview(c)">裁剪</el-button>
                    <br>
                    <el-input v-model="blank[c]" style="width: 240px" :placeholder=i.toString() class="input-demo" />
                </el-col>
            </el-row>

            <el-button type="primary" size="large" style="margin-bottom: 2rem;" @click="handleConcat">生成</el-button>
            <el-button size="large" style="margin-bottom: 2rem;" :disabled="downloadable"
                @click="download('#cvs')">下载</el-button>
            <el-dialog v-model="dialogVisible">
                <img style="width:100%" :src="dialogImageUrl" alt="Preview Image" />
            </el-dialog>
            <br>
            <el-dialog v-model="cropperVisible">
                <div class="cropper-content">
                    <div class="cropper">
                        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size"
                            :outputType="option.outputType" :info="true" :full="option.full" :canMove="option.canMove"
                            :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop"
                            :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
                            :fixedBox="option.fixedBox" @realTime="realTime" @imgLoad="imgLoad"></vueCropper>
                    </div>
                    <div class="show-preview"
                        :style="{ 'width': previews.w + 'px', 'height': previews.h + 'px', 'overflow': 'hidden', 'margin': '5px' }">
                        <div :style="previews.div" class="preview">
                            <img :src="previews.url" :style="previews.img">
                        </div>
                    </div>
                    <!-- <div class="show-preview"
                        :style="{ 'width': previews.w + 'px', 'height': previews.h + 'px', 'overflow': 'hidden', 'margin': '5px' }">
                        <div :style="previews.div" class="preview">
                            <img :src="previews.url" :style="previews.img">
                        </div>
                    </div> -->
                </div>

                <div class="footer-btn">
                    <div class="scope-btn">
                        <label class="btn" for="uploads">更换图片</label>
                        <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                            accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 1)">

                        <button @click="changeScale(1)">+</button>
                        <button @click="changeScale(-1)">-</button>
                        <button @click="rotateLeft">↺</button>
                        <button @click="rotateRight">↻</button>
                    </div>
                    <div class="upload-btn">
                        <button @click="save('blob')">确认</button>
                    </div>
                    <!-- <div class="upload-btn">
                    <button @click="down('blob')">下载</button>
                </div> -->
                </div>
            </el-dialog>
            <canvas id="cvs"></canvas>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { VueCropper } from "vue-cropper";
import 'vue-cropper/dist/index.css'
import { Plus } from '@element-plus/icons-vue'
import { ref, getCurrentInstance } from "vue";

const title = "九宫格生成器"
const subtitle = "……真的假的？"

const { proxy } = getCurrentInstance()
const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const cropperVisible = ref(false)
const hideUploadBtn = ref(false)
const currentImg = ref(0)
const downloadable = ref(true)

const crap = false
const previews = ref({})
const option = ref({
    img: 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
    size: 1,
    full: false,//输出原图比例截图 props名full
    canMove: true,
    original: false,
    canMoveBox: true,
    autoCrop: true,
    outputType: 'png',
    autoCropWidth: 325,
    autoCropHeight: 325,
    fixedBox: true
})
const downImg = ref('#')
const urls = ref([])

function changeScale(num) {
    num = num || 1
    proxy.$refs.cropper.changeScale(num)
}
function rotateLeft() {
    proxy.$refs.cropper.rotateLeft()
}
function rotateRight() {
    proxy.$refs.cropper.rotateRight()
}
// function finish(type) {
//     // 输出
//     // var test = window.open('about:blank')
//     // test.document.body.innerHTML = '图片生成中..' 
//     if (type === 'blob') {
//         this.$refs.cropper.getCropBlob((data) => {
//             var img = window.URL.createObjectURL(data)
//             this.model = true
//             this.modelSrc = img
//         })
//     } else {
//         this.$refs.cropper.getCropData((data) => {
//             this.model = true
//             this.modelSrc = data
//         })
//     }
// }

// 实时预览函数 
function realTime(data) {
    previews.value = data
}

function save(type) {
    // event.preventDefault() 
    var aLink = document.createElement('a')
    aLink.download = 'author-img'
    // 输出
    if (type === 'blob') {
        proxy.$refs.cropper.getCropBlob((data) => {
            downImg.value = window.URL.createObjectURL(data);
            var img = new Image;
            img.src = downImg.value;
            img.onload = function () {//必须onload之后再画
                const w = img.width
                const h = img.height
                urls.value.splice(currentImg.value, 0, [downImg.value, w, h, currentImg.value])
                dialogImageUrl.value = downImg.value
            }
        })
        cropperVisible.value = false
    } else {
        // proxy.$refs.cropper.getCropData((data) => {
        //     downImg.value = data
        // })
    }
}

// function down(type) {
//     // event.preventDefault() 
//     var aLink = document.createElement('a')
//     aLink.download = 'author-img'
//     // 输出
//     if (type === 'blob') {
//         this.$refs.cropper.getCropBlob((data) => {
//             console.log(data)
//             this.downImg = window.URL.createObjectURL(data)
//             // aLink.download = this.downImg; 
//             console.log(this.downImg)
//             aLink.href = window.URL.createObjectURL(data)
//             aLink.click()
//         })
//     } else {
//         this.$refs.cropper.getCropData((data) => {
//             this.downImg = data
//             aLink.href = data
//             aLink.click()
//         })
//     }
// }

function uploadImg(e, num) {
    //上传图片 
    // this.option.img
    var file = e.target.files[0]
    if (! /\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
    }
    var reader = new FileReader()
    reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
            data = e.target.result
        }
        if (num === 1) {
            option.value['img'] = data
            console.log(option.value['img'])
        } else if (num === 2) {
            example2.img = data
        }
    }
    // 转化为base64 
    // reader.readAsDataURL(file)
    // 转化为blob 
    reader.readAsArrayBuffer(file)
}

function imgLoad(msg) {
    console.log(msg)
}

function download(selector) {
    // 通过 API 获取目标 canvas 元素
    const canvas = document.querySelector(selector);

    // 创建一个 a 标签，并设置 href 和 download 属性
    const el = document.createElement('a');
    // 设置 href 为图片经过 base64 编码后的字符串，默认为 png 格式
    el.href = canvas.toDataURL();
    el.download = '九宫格';

    // 创建一个点击事件并对 a 标签进行触发
    const event = new MouseEvent('click');
    el.dispatchEvent(event);
}


const form_title = ref('阵营九宫格')
const creator = ref('')
const blank = ref(['守序善良',
    '中立善良',
    '混乱善良',
    '守序中立',
    '绝对中立',
    '混乱中立',
    '守序邪恶',
    '中立邪恶',
    '混乱邪恶'
])

const fileList = ref([
    [], [], [], [], [], [], [], [], []
])
const fileMap = ref([])

function handleEditChange(id, n) {
    if (fileList.value[n].length) {
        hideUploadBtn.value = true;
        $(id + 'ul>.el-upload--picture-card').css('display', 'none');
    } else {
        hideUploadBtn.value = false;
        $(id + 'ul>.el-upload--picture-card').css('display', '');
    }
}

const handlePreview = (uploadFile) => {
    if (!dialogImageUrl.value) {
        dialogImageUrl.value = uploadFile.url
    }
    dialogVisible.value = true
}

const handleCropperPreview = (n) => {
    if (fileList.value[n][0]) {
        option.value.img = fileList.value[n][0].url
        cropperVisible.value = true
        currentImg.value = n
    } else {
        proxy.$message.error('请先上传图片，再进行裁剪操作')
    }
}

const changeFile = () => {

}

const submitUpload = () => {

}


const handleConcat = () => {
    // if (fileList.value.length != 9) {
    //     proxy.$message.error('图片数量不符，请上传9张图片')
    //     return false;
    // }

    doloop(fileList.value)


    async function doloop(uploadFile) {

        for (let f = 0; f <= uploadFile.length; f++) {
            if (uploadFile[f]) {
                let file = uploadFile[f][0]
                urls.value = await loop(file, f)
            } else {
                urls.value = await loop('', f)
            }
        }
        drawToCanvas()
    }

    function loop(file, f) {
        return new Promise(resolve => {
            if (file) {
                const blob = new Blob([file.raw], { type: ["image/png", 'image/jpg', 'image/jpeg'] })
                const url = window.URL.createObjectURL(blob)
                var img = new Image;
                img.src = url;
                img.onload = function () {//必须onload之后再画
                    const w = img.width
                    const h = img.height
                    urls.value.push([url, w, h, f])
                    resolve(urls.value)
                }
            } else {
                resolve(urls.value)
            }
        })

    }
}


const drawToCanvas = () => {
    var cvs = document.querySelector('#cvs');
    cvs.width = 2480 / 2;
    cvs.height = 3508 / 2;
    cvs.titleHeight = 500 / 2;
    cvs.edge = 150 / 2;
    cvs.rowEdge = 350 / 2;
    cvs.boxWidth = 650 / 2;
    cvs.boxHeight = 650 / 2;
    var ctx = cvs.getContext('2d');

    ctx.font = "20px Georgia";
    ctx.fillStyle = 'black';

    fillBlack(ctx);
    doloopDraw()

    ctx.fillStyle = 'white';
    ctx.font = "70px Georgia";
    ctx.fillText(form_title.value, (cvs.width - ctx.measureText(form_title.value).width) / 2, 100);

    ctx.font = "50px Georgia";
    ctx.fillText('填表人：' + creator.value, (cvs.width - ctx.measureText('填表人：' + creator.value).width) / 2, 200);

    ctx.font = "50px Georgia";
    fillBlank(ctx);

    downloadable.value = false



    function fillBlack(ctx) {
        ctx.fillRect(0, 0, cvs.width, cvs.titleHeight);
        ctx.closePath();
        ctx.fillRect(0, 0, cvs.edge, cvs.height);
        ctx.closePath();
        ctx.fillRect(cvs.width - cvs.edge, 0, cvs.edge, cvs.height);
        ctx.closePath();
        ctx.fillRect(0, cvs.height - cvs.edge, cvs.width, cvs.edge);
        ctx.closePath();
        ctx.fillRect(cvs.edge + cvs.boxWidth, 0, cvs.edge, cvs.height);
        ctx.closePath();
        ctx.fillRect((cvs.edge + cvs.boxWidth) * 2, 0, cvs.edge, cvs.height);
        ctx.closePath();
        ctx.fillRect(0, cvs.titleHeight + cvs.boxHeight, cvs.width, cvs.rowEdge);
        ctx.closePath();
        ctx.fillRect(0, cvs.titleHeight + cvs.boxHeight * 2 + cvs.rowEdge, cvs.width, cvs.rowEdge);
        ctx.closePath();
        ctx.fillRect(0, cvs.titleHeight + cvs.boxHeight * 3 + cvs.rowEdge * 2, cvs.width, cvs.rowEdge);
        ctx.closePath();
    }

    function fillBlank(ctx) {
        let u = 0;
        for (let b of Object.entries(blank.value)) {
            let n = b[0];
            let i = b[1];
            let w = cvs.edge + (u % 3) * (cvs.edge + cvs.boxWidth) + (cvs.boxWidth - ctx.measureText(i).width) / 2;
            let h = cvs.titleHeight + cvs.boxHeight + Math.floor(u / 3) * (cvs.rowEdge + cvs.boxHeight) + 100;
            ctx.fillText(i, w, h);
            u++;
        }

    }

    async function doloopDraw() {
        console.log(urls.value.length - 1)
        for (let u = urls.value.length - 1; u >= 0; u--) {
            await loopDraw(urls.value[u], urls.value[u][3])
        }
    }

    function loopDraw(url, u) {
        return new Promise(resolve => {
            if (url[0]) {
                var img = new Image;
                img.src = url[0];
                img.onload = function () {//必须onload之后再画
                    let current_width = cvs.edge + (u % 3) * (cvs.edge + cvs.boxWidth)
                    let current_height = cvs.titleHeight + Math.floor(u / 3) * (cvs.rowEdge + cvs.boxHeight)
                    let w = cvs.boxWidth
                    let h = cvs.boxHeight
                    ctx.fillRect(current_width, current_height, w, h);
                    ctx.closePath();
                    ctx.drawImage(img, current_width, current_height, w, h);
                    // const strDataURI = cvs.toDataURL();//获取canvas base64数据
                    resolve()
                }
            } else {
                resolve()
            }
        })
    }
}


const checkFileType = (file) => {
    const fileName = file.name
    const fileType = fileName.substring(fileName.lastIndexOf('.'))
    if (
        fileType === '.jpg' ||
        fileType === '.png' ||
        fileType === '.jpeg'
    ) {
        // 不处理
    } else {
        proxy.$message.error('请上传正确的图片类型')
        return false
    }
}
</script>
<style scoped>
.cropper-content {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;

    .cropper {
        width: 500px;
        height: 500px;
    }

    .show-preview {
        flex: 1;
        -webkit-flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;

        .preview {
            overflow: hidden;
            border-radius: 50%;
            border: 1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
        }
    }
}

.footer-btn {
    margin-top: 30px;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;

    .scope-btn {
        width: 350px;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
    }

    .upload-btn {
        flex: 1;
        -webkit-flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;
    }

    .btn {
        outline: none;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
        color: #fff;
        background-color: #67c23a;
        border-color: #67c23a;
    }
}
</style>